export default __webpack_public_path__ + "static/media/insta_prof.d309ac9a.png";